import { React, useEffect, useState } from "react";
import Main from "../layout/Main";
import {
  Badge,
  Card,
  Col,
  Row,
  Button,
  FormLabel,
  FormControl,
  Form,
  Container,
  Stack,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Dashboard.css";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import LineChartAMC from "./LineChartAMC";
import PieChart from "./PieChart";
import DonutChart from "./DonutChart";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import EventEdit from "./EventEdit";
import LeadTableDashboard from "./LeadTableDashboard";
import { WarrantyTableDashboard } from "./DashboardTables";
import { ROUTES } from "../../constants/webRouting";
import DashboardNew from "./DashboardNew";
import DateRangePicker from "rsuite/DateRangePicker";
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/DateRangePicker/styles/index.css";
import { formatDate, getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";

const Dashboard = () => {
  const userInfo = getUserDetails();
  const [panelData, setPanelData] = useState({});
  const [dateRange, setDateRange] = useState([
    // new Date(),
    // new Date()
  ]);
  // const [leadsUserWise, setLeadsUserWise] = useState([]);
  // const [leadCount, setLeadCount] = useState(0);
  // const [offerUnits, setOfferUnits] = useState(null);
  // const [totalUnitsordersReceived, setTotalUnitsordersReceived] = useState(0);
  // const [totalUnitsOfWarranty, setTotalUnitsOfWarranty] = useState(0);
  // const [orderUnits, setOrderUnits] = useState([]);
  // const [totalOrderRevenue, setTotalOrderRevenue] = useState(null);
  // const [totalAMCRevenue, setTotalAMCRevenue] = useState(0);
  // const [lostLeads, setLostLeads] = useState([]);
  // const [amcCount, setAmcCount] = useState(null);
  // const [todayMeetings, setTodayMeetings] = useState([]);
  const [showEventModel, setShowEventModel] = useState(false);
  const [filterDate, setFilterDate] = useState({});


  useEffect(() => {
    console.log('dateRange', dateRange);
    init();
  }, [dateRange]);


  async function init() {
    try {
      const filterDate = {};
      if (Array.isArray(dateRange)) {
        const [fromDate, toDate] = dateRange;
        if (fromDate && toDate) {
          filterDate.fromDate = formatDate(fromDate);
          filterDate.toDate = formatDate(toDate);
        }
      }
      
      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_LEAD, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchLeadCount(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'newEnquires': result?.at(0)?.total_new_enquires }));
        } else {
          setPanelData((pre) => ({ ...pre, 'newEnquires': '' }));
        }
      }
      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchSiteVisits(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (Array.isArray(result)) {
          setPanelData((pre) => ({ ...pre, 'siteVisits': result }));
        } else {
          setPanelData((pre) => ({ ...pre, 'siteVisits': [] }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchOfferUnitsTotal(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (Array.isArray(result)) {
          setPanelData((pre) => ({ ...pre, 'offers': result }));
        } else {
          setPanelData((pre) => ({ ...pre, 'offers': [] }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })){
        let result = await fuziElevatorsApi.fetchTotalOrdersReceived(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (Array.isArray(result)) {
          setPanelData((pre) => ({ ...pre, 'orders': result }));
        } else {
          setPanelData((pre) => ({ ...pre, 'orders': [] }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchTotalHandovers(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'totalHandovers': (Number(result?.at(0)?.total_handovers) || 0) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'totalHandovers': 0 }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchWarrantyDue(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'warrantyDue': (Number(result?.at(0)?.warranty_due) || 0) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'warrantyDue': 0 }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchAMCDue(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'amcDue': (Number(result?.at(0)?.amc_due) || 0) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'amcDue': 0 }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchTotalOrderRevenue(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'orderRevenue': (parseFloat((Number(result?.at(0)?.order_revenue) || 0) / 100000)?.toFixed(2)) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'orderRevenue': 0 }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchTotalAMCRevenue(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'amcRevenue': (parseFloat((Number(result?.at(0)?.amc_revenue) || 0) / 100000)?.toFixed(2)) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'amcRevenue': 0 }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchAMCTotal(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'unitsInAMC': result?.at(0)?.total_amc_units }));
        } else {
          setPanelData((pre) => ({ ...pre, 'unitsInAMC': '' }));
        }
      }

      if([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await fuziElevatorsApi.fetchTotalUnitsInWarranty(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'unitsInWarranty': result?.at(0)?.total_warranty_units }));
        } else {
          setPanelData((pre) => ({ ...pre, 'unitsInWarranty': '' }));
        }
      }


      // const fetchLeadsUserWise = 0; // await fuziElevatorsApi.fetchLeadUserWise(filterDate);


    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  }

  const submitEvents = async (eventRec) => {
    ////console.log('eventRec home submit', eventRec)
    setShowEventModel(false);
    init();
  };

  return (
    <Main>
      <Container className="d-flex flex-column gap-3 ">
        <Row className="bg-white py-3 rounded">
          <Col md={4} >
            <Stack>
              <span>Select Date</span>
              <DateRangePicker
                value={dateRange}
                onChange={(e) => {
                  setDateRange(e);
                }}
                // format="dd/mm/yyyy"
                character=" – "
              />
            </Stack>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Container>
              <DashboardNew panelData={panelData} />
            </Container>
          </Col>
          <Col lg={6} style={{ border: "12px" }}>
            <Card>
              <Card.Body>
                <h4 className="text-center">LEAD STAGE REPORT</h4>
                <DonutChart dateRange={dateRange} />
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <div style={{ height: "350px" }}>
              <Card className="">

                <div className="user-container">
                  <div className="flex-container">

                    <div className="not-contacted-leads-section">
                      <h4 className="text-center">Not Contacted Leads</h4>
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <LeadTableDashboard dateRange={dateRange} />
                      </table>
                    </div>
                  </div>
                </div>
                <div className="not-contacted-leads-section">
                  <h4 className="text-center">Warranty Current Month</h4>
                  <table
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <WarrantyTableDashboard dateRange={dateRange} />
                  </table>
                </div>
              </Card>
            </div>
          </Col>
        </Row>

        <Row >
          <Col lg={6} >
            <Card>
              <Card.Body>
                <div style={{ marginBottom: "10px" }}>
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ width: "100%" }}>
                      <h4 className="text-center">ORDER REVENUE LAST MONTH</h4>
                      <LineChart dateRange={dateRange} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  ></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6} >
            <Card>
              <Card.Body>
                <div style={{ marginBottom: "10px" }}>
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ width: "100%" }}>
                      <h4 className="text-center">AMC REVENUE LAST MONTH</h4>
                      <LineChartAMC dateRange={dateRange} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  ></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {showEventModel && (
          <EventEdit
            show={showEventModel}
            onHide={() => setShowEventModel(false)}
            parentid="abc"
            //eventRec={event}
            table="user"
            submitEvents={submitEvents}
          />
        )}
      </Container>
    </Main>
  );
};

export default Dashboard;
